var moduleFiles = require.context('./',true,/\.js$/)
var modules = {}
moduleFiles.keys().forEach( file => {
    if(file.match(/index.js$/)) return
    const moduleName = file.split('/').pop().replace(/\.[^/.]+$/, "")
    import('./'+moduleName).then(m => {
        modules = Object.assign(modules, m.default)
    })
})

/**
 * Get the URL for a model
 *
 * @param {string} model A filename under src/models/ without the extension
 * @param {string} action A method on the model
 *   - for legacy URLs, typically 'read', 'create', 'update', 'destroy' which resolve to different URLs
 *   - for OpenAPI-style URLs that support HTTP methods (GET, POST, PUT, PATCH, DELETE), use `resource` or `collection`. These support URL path substituion parameters using `uri` template literals by importing `./uri`
 *      - example: `modules.getUrl('interventionReminders', 'resource', { id: 1 })` resolves to `/api/v3/intervention/plan/1/reminder` because:
 *        ```js
 *        interventionReminders: {
 *          resource: {
 *            endpoint: uri`/api/v3/intervention/plan/${"id"}/reminder`,
 *          }
 *        }
 *        ```
 * @param {object} params Additional parameters to add to the URL. Will be used to substitute URL path substituion parameters using `uri` template literals for OpenAPI-style URLs.
 * @returns {string} The URL for the model
 */
modules.getUrl = function(model, action, params={}) {
    if (this[model]) {
        let m = this[model]
        let url = m[action].endpoint ? m[action].endpoint : m.defaults.endpoint
        let p = Object.assign({}, m.defaults?.params || {}, m?.[action]?.params || {}, params || {})
        if (typeof url === 'function') {
            url = url(p)
        }
        for (let key in p) {
            url += (url.indexOf('?') > -1 ? '&' : '?') + key + '=' + encodeURIComponent(p[key])
        }

        return url
    } else {
        console.error('Invalid model endpoint', model, action)
        return
    }
}

export default modules
